import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        compareQuestion: '=',
        counter: '=',
        title: '=',
        compareTitle: '=',
        showIndividualAnswers: '='
    },
    template: `
        <h4>{{ vm.counter }}. {{ vm.question.nameWithoutHtml }}</h4>
        <ul class="ticks"><li ng-repeat="answer in vm.question.questionAnswers">{{ answer.text }}</li>
        </ul>
        <dl>
            <dt>{{ 'answer.Average score' | translate }}</dt>
            <dd>
                <span>
                    <span ng-if="vm.compareTitle && vm.getAverage()" class="title" >
                    <strong class="ng-binding">{{ vm.title }}</strong>
                    </span>
                    <span class="result" ng-style="{ width: vm.SurveyReportService.getWidth(vm.getAverage(), vm.answerCount) }">
                        <span>{{ vm.getAverage() | number: 1 }}</span>
                    </span>
                </span>
                <span ng-if="vm.compareQuestion">
                    <span class="title" ng-if="vm.compareTitle && vm.getCompareAverage()">
                        <strong class="ng-binding">{{ 'survey.Comparison' | translate }}</strong>
                    </span>
                    <span ng-if="vm.compareQuestion && vm.getCompareAverage()"
                        class="result result02" ng-style="{ marginTop: '0px', width: vm.SurveyReportService.getWidth(vm.getCompareAverage(), vm.answerCount) }">
                        <span>{{ vm.getCompareAverage() | number: 1 }}</span>
                    </span>
                </span>
            </dd>
        </dl>

        <div ng-if="vm.showIndividualAnswers">
            <h4>{{ 'survey.Results' | translate }}</h4>
            <dl ng-repeat="answer in vm.question.questionAnswers">
                <dt>{{ answer.text }}</dt>
                <dd>
                    <span ng-if="vm.getAnswerCount(answer.id)">
                        <span ng-if="vm.compareTitle && vm.getAnswerCount(answer.id)" class="title" >
                        <strong class="ng-binding">{{ vm.title }}</strong>
                        </span>
                        <span class="result" ng-style="{ width: vm.getWidth(answer.id) }">
                            <span>{{ vm.getAnswerCount(answer.id) }} ({{ vm.getPercentage(answer.id) }}%)</span>
                        </span>
                    </span>
                    <span ng-if="vm.compareQuestion">
                        <span class="title" ng-if="vm.compareTitle && vm.getCompareAnswerCount(answer.id)">
                            <strong class="ng-binding">{{ 'survey.Comparison' | translate }}</strong>
                        </span>
                        <span ng-if="vm.compareQuestion && vm.getCompareAnswerCount(answer.id)"
                            class="result result02" ng-style="{ width: vm.getCompareWidth(answer.id), marginTop: '0px' }">
                            <span>{{ vm.getCompareAnswerCount(answer.id) }} ({{ vm.getComparePercentage(answer.id) }}%)</span>
                        </span>
                    </span>
                </dd>
            </dl>
        </div>
    `
})
export default class {
    constructor (lodash, SurveyReportService, QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM) {
        this.lodash = lodash;
        this.SurveyReportService = SurveyReportService;
        this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM = QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM;
    }

    $onInit () {
        this.question.questionAnswers = this.question.questionAnswers
            .filter(answer => answer.correctness !== this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.KEYS.NOT_APPLICABLE);
        this.answerCount = this.question.questionAnswers.length;

        if (this.compareQuestion) {
            this.compareQuestion.questionAnswers = this.compareQuestion.questionAnswers
                .filter(answer => answer.correctness !== this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.KEYS.NOT_APPLICABLE);

            if (this.compareQuestion.questionAnswers.length > this.answerCount) {
                this.answerCount = this.compareQuestion.questionAnswers.length;
            }
        }
    }

    getAverage () {
        if (!this.question.answerOptions.average) {
            return 0;
        }
        return parseFloat(this.question.answerOptions.average);
    }

    getCompareAverage () {
        if (!this.compareQuestion.answerOptions.average) {
            return 0;
        }
        return parseFloat(this.compareQuestion.answerOptions.average);
    }

    getWidth (answerId) {
        if (!this.question.answerOptions.counts[answerId]) {
            return 0;
        }
        const width = parseFloat(this.getAnswerCount(answerId) * 100 / this.getCalculatedTotalCount());
        return `${width}%`;
    }

    getCalculatedTotalCount () {
        if (!this.compareQuestion.answerOptions || !this.compareQuestion.answerOptions.count) {
            return this.question.answerOptions.count;
        }

        if (parseFloat(this.question.answerOptions.count) > parseFloat(this.compareQuestion.answerOptions.count)) {
            return this.question.answerOptions.count;
        }

        return this.compareQuestion.answerOptions.count;
    }

    getAnswerCount (answerId) {
        if (!this.question.answerOptions.counts[answerId]) {
            return 0;
        }
        return this.question.answerOptions.counts[answerId].answer_count;
    }

    getCompareWidth (answerId) {
        if (!this.compareQuestion.answerOptions.counts[answerId]) {
            return 0;
        }
        const width = parseFloat(this.getCompareAnswerCount(answerId) * 100 / this.getCalculatedTotalCount());
        return `${width}%`;
    }

    getCompareAnswerCount (answerId) {
        if (!this.compareQuestion.answerOptions.counts[answerId]) {
            return '';
        }
        return this.compareQuestion.answerOptions.counts[answerId].answer_count;
    }

    getPercentage (answerId) {
        return Math.round(100 * this.getAnswerCount(answerId) / this.question.answerOptions.count);
    }

    getComparePercentage (answerId) {
        return Math.round(100 * this.getCompareAnswerCount(answerId) / this.compareQuestion.answerOptions.count);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/report/question/scale/index.js